
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class PriorityBadge extends Vue {
  @Prop({ type: Number, default: 0 }) priorityScore!: number;
  
  public get priorityLevel(): string {
    if (this.priorityScore >= 80) return 'Critical';
    if (this.priorityScore >= 60) return 'High';
    if (this.priorityScore >= 30) return 'Normal';
    return 'Low';
  }
  
  public get badgeColor(): string {
    switch (this.priorityLevel.toLowerCase()) {
      case 'critical': return '#f6687b';
      case 'high': return '#faaf3b';
      case 'normal': return '#59C8E4';
      case 'low': return '#99be50';
      default: return '#59C8E4';
    }
  }
  
  public get priorityIcon(): string {
    switch (this.priorityLevel.toLowerCase()) {
      case 'critical': return 'mdi-alert-octagon';
      case 'high': return 'mdi-alert';
      case 'normal': return 'mdi-information';
      case 'low': return 'mdi-check-circle';
      default: return 'mdi-information';
    }
  }
}
